<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="vb-primary">
      <b-navbar-brand href="#"><img src="/images/assets/logo/RPD_logotype_skyblue.png" alt="Logo"
          class="logo-img"></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item @click="openTab = { title: 'Unit Mix', value: 'unitmix' }, toggleView()">Unit Mix</b-nav-item>
          <!-- <b-nav-item @click="openTab = { title: 'Unit Mix Rental', value: 'unitmixrental' }, toggleView()">Unit Mix
            Rental</b-nav-item> -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div v-if="openTab.value === 'unitmix', showTabulator = true">
      <div v-if="showTabulator" ref="tabulatorTable" key="tabulator-view"></div>
    </div>
    <!-- <div v-if="openTab.value === 'unitmixrental', showTabulator = true">
      <div v-if="showTabulator" ref="tabulatorTable" key="tabulator-view"></div>
    </div> -->

    <b-modal v-model="saveRowModalShow" title="Save Entry Type" @ok="confirmRowSave" ok-title="Confirm Save" centered>
      <p class="mb-3">Select all entry types that apply:</p>

      <b-form-group>
        <b-form-checkbox v-model="entryTypeSelection.isNewEntry" value="1" unchecked-value="0" class="mb-2">
          New Entry
        </b-form-checkbox>

        <b-form-checkbox v-model="entryTypeSelection.isOriginalEntry" value="1" unchecked-value="0">
          Original Entry
        </b-form-checkbox>
      </b-form-group>

      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="secondary" @click="cancel()">Cancel</b-button>
        <b-button size="sm" variant="success" @click="ok()">Confirm Save</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import RpdTable from '../common/RpdTable.vue';
import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { wrapColumns } from "../../utilities/tabulatorSorter";
import Vue from "vue";
import axios from 'axios';
import { BACKEND_URL, ROOT_URL } from "../../variables.js";

// Components
import CheckboxCell from './../tabulator_components/CheckboxCell.vue';
import UpdateMlsCell from "./../tabulator_components/UpdateMlsCell.vue";
import FavoriteCell from "./../tabulator_components/FavoriteCell.vue";
import HeaderUpdateBtn from "./../tabulator_components/HeaderUpdateBtn.vue";
import BedsCell from "./../tabulator_components/BedsCell.vue";
import SaveRowCell from "./../tabulator_components/SaveRowCell.vue";
import AddressCell from "./../tabulator_components/AddressCell.vue";
import FileUploadCell from "./../tabulator_components/FileUploadCell.vue";
import DateCell from "./../tabulator_components/DateCell.vue";

const UpdateMlsCellComponent = Vue.extend(UpdateMlsCell);
const CheckboxCellComponent = Vue.extend(CheckboxCell);
const FavoriteCellComponent = Vue.extend(FavoriteCell);
const HeaderUpdateBtnComponent = Vue.extend(HeaderUpdateBtn);
const BedsCellComponent = Vue.extend(BedsCell);
const SaveRowCellComponent = Vue.extend(SaveRowCell);
const AddressCellComponent = Vue.extend(AddressCell);
const FileUploadCellComponent = Vue.extend(FileUploadCell);
const DateCellComponent = Vue.extend(DateCell);

export default {
  components: {
    RpdTable
  },
  props: {
    mlsData: {
      type: Array,
    },
    rentalData: {
      type: Array,
    },
    row_data: { type: Array, default: () => [] },
    header_fields: { type: Array, default: () => [] },
  },
  data() {
    return {
      openTab: { title: 'Unit Mix', value: 'unitmix' },
      showTabulator: false,
      saveRowModalShow: false,
      rowToSave: null,
      selectedSaveEntryType: 'new entry',
      entryTypeSelection: {
        isAssignment: 0,
        isNewEntry: 0,
        isOriginalEntry: 0
      },
      isBusy: false,
      // tabulator: null,
    }
  },
  computed: {
    model_rowdata() {
      return this.openTab.value === 'unitmix' ? this.mlsData : this.rentalData;
    },

    tabulatorColumns: {
      get: function () {
        const vm = this;
        let headers;
        headers = this.header_fields.filter(h => !["checkbox", "updatemls"].includes(h.key)).map(field => {
          return {
            label: field.label,
            key: field.key
          };
        });

        const headersWithActions = [
          { label: "Actions", key: "row_save_btn", width: 80 },  // Position 2: Save
          ...headers,
        ];
        const editableNumericFields = [
          "mls_beds", "mls_baths", "mls_unit_size", "parking",
          "mls_list_price", "mls_sold_price", "buyer_incentives", "realtor_incentives", "balcony_area", "mls_parking"
        ];

        const editableMultiSelectFields = [
          "fp_specs", "levels", "balcony", "stalls", "custom_status", "orientation", "price_back_up"
        ];

        const currencyFields = [
          "mls_list_price", "mls_sold_price", "list_price_net",
          "net_price", "buyer_incentives", "realtor_incentives",
          "custom_parking_stall_cost", "custom_storage_locker_cost"
        ];

        const psfFields = ["custom_mls_net_psf", "custom_sold_psf", "custom_net_psf", "mls_psf"];
        const dateFields = ["mls_price_date", "mls_sold_date", "price_date", "mls_list_date"];
        const priceBackupOptions = [
          { label: "Verified", value: "Verified" },
          { label: "Semi-Verified", value: "Semi-Verified" },
          { label: "Educated Estimated", value: "Educated Estimated" }
        ];
        const fpSpecsSource = [
          { "name": "Furnished", "value": "21170" },
          { "name": "None", "value": "11104" },
          { "name": "Den", "value": "10965" },
          { "name": "Jr Bed", "value": "10971" },
          { "name": "Sub-PH", "value": "10967" },
          { "name": "PH", "value": "10966" },
          { "name": "TH", "value": "10970" },
          { "name": "Roof Deck", "value": "10964" },
          { "name": "Bonus Room", "value": "11040" },
          { "name": "Den (2)", "value": "11132" },
          { "name": "Jr Bed (2)", "value": "21139" },
          { "name": "Live/Work", "value": "11039" },
          { "name": "Lock-Off", "value": "10968" },
          { "name": "Loft", "value": "11028" }
        ];
        const fpSpecsFormatted = fpSpecsSource.map(item => ({
          label: item.name,
          value: item.value
        }));

        const orientationSource = [
          { "text": "None", "value": 11105 },
          { "text": "East", "value": 11033 },
          { "text": "North", "value": 11030 },
          { "text": "North East", "value": 11035 },
          { "text": "North West", "value": 11034 },
          { "text": "South", "value": 11032 },
          { "text": "South East", "value": 11037 },
          { "text": "South West", "value": 11036 },
          { "text": "West", "value": 11031 }
        ];

        const orientationFormatted = orientationSource.map(item => ({
          label: item.text,
          value: item.value
        }));
        const stallsSource = [
          { "text": "None", "value": "11107" }, { "text": "Pad", "value": "21140" }, { "text": "Double", "value": "11110" },
          { "text": "Single", "value": "11108" }, { "text": "Tandem", "value": "11109" }, { "text": "Triple", "value": "21136" },
          { "text": "U/G", "value": "11111" }, { "text": "Null", "value": 0 }
        ];

        const stallsFormatted = stallsSource.map(item => ({
          label: item.text,
          value: item.value
        }));

        const levelsSource = [
          { "text": "None", "value": "11106" }, { "text": "1 Level", "value": "11074" }, { "text": "2 Level", "value": "11075" },
          { "text": "3 Level", "value": "11076" }, { "text": "4 Level", "value": "11077" }, { "text": "5 Level", "value": "11113" }
        ];

        const levelsFormatted = levelsSource.map(item => ({
          label: item.text,
          value: item.value
        }));
        const mlsStatusSource = [
          { "text": "None", "value": 11482 },
          { "text": "Active", "value": 8197 },
          { "text": "Sold", "value": 8198 },
          { "text": "Unreleased", "value": 23440 }
        ];

        const mlsStatusFormatted = mlsStatusSource.map(item => ({
          label: item.text || "None",
          value: item.value
        }));
        const multiSelectOptions = {
          levels: ["1", "2", "3", "4+"],
          balcony: ["Yes", "No"],
        };
        return headersWithActions.map(col => {
          let displayTitle = col.label;
          if ([...editableNumericFields, ...editableMultiSelectFields].includes(col.key)) {
            displayTitle += " *";
          }

          let columnConfig = {
            field: col.key,
            title: displayTitle,
            vertAlign: "middle",
            hozAlign: "left"
          };

          columnConfig.sorter = (a, b, aRow, bRow, column, dir, params) => {
            const aReal = this.isRealValue(a);
            const bReal = this.isRealValue(b);
            if (col.key === "custom_price_confidence") {
              const customOrder = {
                Verified: 1,
                Low: 2,
                Medium: 3,
                High: 4,
              };

              const valA = customOrder[a];
              const valB = customOrder[b];

              if (valA !== undefined && valB !== undefined) {
                return valA < valB ? -1 : (valA > valB ? 1 : 0);
              }

              if (dir === "desc") {
                if (valA === undefined && valB !== undefined) return -1;
                if (valB === undefined && valA !== undefined) return 1;
                return 0;
              } else {
                if (valA === undefined && valB !== undefined) return 1;
                if (valB === undefined && valA !== undefined) return -1;
                return 0;
              }
            }
            if (!aReal && !bReal) return 0;
            if (!aReal) return dir === "asc" ? 1 : -1;
            if (!bReal) return dir === "asc" ? -1 : 1;

            const parseCustomDate = (dateStr) => {
              if (!dateStr || typeof dateStr !== "string") return 0;
              const parts = dateStr.split("-");
              if (parts.length !== 3) return new Date(dateStr).getTime() || 0;
              const months = {
                Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
                Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
              };
              const day = parseInt(parts[0]);
              const month = months[parts[1]];
              const year = parseInt(parts[2]) < 100 ? 2000 + parseInt(parts[2]) : parseInt(parts[2]);
              return new Date(year, month, day).getTime();
            };

            const isDateField = column.getField().toLowerCase().includes("date");
            const dateRegex = /^\d{1,2}-[A-Za-z]{3}-\d{2}$/;

            if (isDateField || (dateRegex.test(a) && dateRegex.test(b))) {
              return parseCustomDate(a) - parseCustomDate(b);
            }

            const isNumeric = (val) => !isNaN(val) && !isNaN(parseFloat(val));
            if (isNumeric(a) && isNumeric(b)) {
              return parseFloat(a) - parseFloat(b);
            }

            const strA = (a || "").toString().toLowerCase();
            const strB = (b || "").toString().toLowerCase();
            return strA.localeCompare(strB);
          };

          const mountVueComponent = (cell, Component, props) => {
            const data = cell.getData();
            if (!data || Object.keys(data).length === 0) return "";
            const container = document.createElement("div");
            const componentInstance = new Component({
              propsData: props
            });
            componentInstance.$mount(container);
            cell.getTable().on("cellDestroyed", (deletedCell) => {
              if (deletedCell === cell) {
                componentInstance.$destroy();
              }
            });
            return componentInstance.$el;
          };

          if (col.key === "row_save_btn") {
            columnConfig.formatter = (cell) => {
              const data = cell.getData();
              if (!data.isEdited) return "";
              const container = document.createElement("div");
              const componentInstance = new SaveRowCellComponent({
                propsData: { row: data }
              });
              componentInstance.$mount(container);
              componentInstance.$on('save', (rowData) => {
                this.handleRowSave(rowData);
              });
              return componentInstance.$el;
            };
          }
          if (editableMultiSelectFields.includes(col.key)) {
            let listValues = [];
            if (col.key === 'fp_specs') {
              listValues = fpSpecsFormatted;
            } else if (col.key === 'orientation') {
              listValues = orientationFormatted;
            } else if (col.key === 'stalls') {
              listValues = stallsFormatted;
            } else if (col.key === 'levels') {
              listValues = levelsFormatted;
            } else if (col.key === 'custom_status') {
              listValues = mlsStatusFormatted;
            } else if (col.key === 'price_back_up') {
              listValues = priceBackupOptions;
            } else {
              listValues = multiSelectOptions[col.key] || [];
            }

            columnConfig.editor = "list";
            columnConfig.editorParams = {
              values: listValues,
              multiselect: col.key == 'fp_specs' ? true : false,
              autocomplete: false,
              allowEmpty: true,
              listOnEmpty: true,
              verticalNavigation: "editor",
            };

            columnConfig.formatter = (cell) => {
              const val = cell.getValue();
              const element = cell.getElement();
              if (!this.isRealValue(val)) return "-";

              const selectedArray = Array.isArray(val)
                ? val
                : val.toString().split(",").map(i => i.trim());

              // 1. Generate the Text Label(s)
              const labels = selectedArray.map(v => {
                let match;
                switch (col.key) {
                  case 'custom_status':
                    match = mlsStatusSource.find(opt => opt.value == v || opt.text == v);
                    return match ? (match.text || "None") : v;
                  case 'levels':
                    match = levelsSource.find(opt => opt.value == v || opt.text == v);
                    return match ? match.text : v;
                  case 'stalls':
                    match = stallsSource.find(opt => opt.value == v || opt.text == v);
                    return match ? match.text : v;
                  case 'orientation':
                    match = orientationSource.find(opt => opt.value == v || opt.text == v);
                    return match ? match.text : v;
                  case 'fp_specs':
                    match = fpSpecsSource.find(opt => opt.value == v || opt.name == v);
                    return match ? match.name : v;
                  default:
                    return v;
                }
              });

              const displayText = labels.join(", ");

              if (col.key === 'custom_status') {
                const lowerText = displayText.toLowerCase();
                element.style.fontWeight = "bold";

                if (lowerText.includes("active")) {
                  element.style.color = "#28a745";
                } else if (['sold', 'leased'].some(status => lowerText === status)) {
                  element.style.color = "#dc3545";
                } else if (lowerText.includes("unreleased")) {
                  element.style.color = "#000";
                } else {
                  element.style.color = "#000";
                }
              }

              return displayText;
            };

            columnConfig.cellEdited = (cell) => {
              const rowData = cell.getData();
              if (Array.isArray(rowData[col.key])) {
                rowData[col.key] = rowData[col.key].join(", ");
              }
              rowData.isEdited = true;
              this.syncDataChange(rowData);
              cell.getRow().update({ isEdited: true });
            };
          }
          if (dateFields.includes(col.key)) {
            columnConfig.formatter = (cell) => {
              const data = cell.getData();
              if (!data || Object.keys(data).length === 0) return "";

              const container = document.createElement("div");
              const componentInstance = new DateCellComponent({
                propsData: {
                  row: data,
                  field: col.key,
                  isAdmin: this.isAdmin
                }
              });

              // Listen for the update event
              componentInstance.$on('date-updated', (payload) => {
                // Sync with your Vue data state
                this.syncDataChange(payload.row);
                // Update Tabulator row visually
                cell.getRow().update({ isEdited: true });
              });

              componentInstance.$mount(container);

              // Clean up when cell is destroyed
              cell.getTable().on("cellDestroyed", (deletedCell) => {
                if (deletedCell === cell) {
                  componentInstance.$destroy();
                }
              });

              return componentInstance.$el;
            };
          }
          if (col.key === "attachment") {
            columnConfig.title = "File";
            columnConfig.width = 100;
            columnConfig.hozAlign = "center";
            columnConfig.formatter = (cell) => {
              const container = document.createElement("div");
              const componentInstance = new FileUploadCellComponent({
                propsData: { row: cell.getData(), queryParams: this.$route.query }
              });

              componentInstance.$on('upload-success', (payload) => {
                const row = cell.getRow();
                row.update({
                  mls_attachment_url: payload.newUrl,
                  isEdited: true
                });
                this.syncDataChange(row.getData());
              });

              componentInstance.$on('file-selected', (fileObject) => {
                const row = cell.getRow();
                row.update({
                  pending_file: fileObject,
                  isEdited: true
                });
                this.syncDataChange(row.getData());
              });

              componentInstance.$mount(container);
              return componentInstance.$el;
            };
          }

          else if (psfFields.includes(col.key)) {
            columnConfig.hozAlign = "left";
            columnConfig.formatter = (cell) => {
              const value = cell.getValue();
              const precision = this.isMarketStrata ? 0 : 2;
              return this.applyNumericFormat(value, true, precision);
            };
          }

          else if (currencyFields.includes(col.key)) {
            columnConfig.hozAlign = "left";
            columnConfig.formatter = (cell) => {
              const data = cell.getData();
              const value = cell.getValue();

              if (col.key === "mls_list_price") {
                const element = cell.getElement();
                const status = data.price_back_up || "";
                element.style.color = this.setColor(status);
                element.style.fontWeight = "bold";
              }

              return this.applyNumericFormat(value, true, 0);
            };
          }

          // else if (col.key === "checkbox") {
          //   columnConfig.frozen = true
          //   columnConfig.formatter = (cell) => mountVueComponent(cell, CheckboxCellComponent, {
          //     row: cell.getData(),
          //     listingType: this.listing_type,
          //     onPromptRow: (rowData) => this.promptRow(rowData),
          //     onDeleteRow: (payload) => this.$emit('deleteMlsRentalRow', payload)
          //   });
          //   columnConfig.titleFormatter = (column) => {
          //     const container = document.createElement("div");
          //     container.style.display = "flex";
          //     container.style.justifyContent = "center";
          //     container.textContent = "Select All";
          //     const checkbox = document.createElement("input");
          //     checkbox.type = "checkbox";
          //     checkbox.style.cursor = "pointer";
          //     checkbox.style.marginLeft = "5px";
          //     checkbox.style.width = "16px";
          //     checkbox.style.height = "16px";
          //     checkbox.addEventListener("change", (e) => {
          //       const isChecked = e.target.checked;
          //       const table = column.getTable();
          //       const rows = table.getRows();

          //       rows.forEach(row => {
          //         // Update the row data in Tabulator
          //         // This triggers a re-render of the cell formatter (your Vue component)
          //         row.update({ rowSelected: isChecked });

          //         // Sync the change back to your Vue data state
          //         const updatedData = row.getData();
          //         this.syncDataChange(updatedData);
          //       });
          //     });

          //     container.appendChild(checkbox);
          //     return container;
          //   };
          // }

          else if (col.key === "updatemls") {
            columnConfig.formatter = (cell) => mountVueComponent(cell, UpdateMlsCellComponent, {
              row: cell.getData(),
              openTab: this.openTab,
              showFlag: this.showFlag,
              isAdmin: this.isAdmin,
              isMarketStrata: this.isMarketStrata,
              onUpdateMls: (payload) => this.$emit('updateMls', payload)
            });
          }

          else if (col.key === "favorite") {
            columnConfig.hozAlign = "center";
            columnConfig.width = 50;
            columnConfig.formatter = (cell) => mountVueComponent(cell, FavoriteCellComponent, {
              row: cell.getData(),
              isFavorite: cell.getValue(),
              onToggleFavorite: (rowData) => this.$emit('toggleFavorite', rowData)
            });
          }

          if (col.key === "mls_address") {
            columnConfig.width = 250;
            columnConfig.frozen = true;

            columnConfig.formatter = (cell) => {
              const data = cell.getData();
              if (!data || Object.keys(data).length === 0) return "";

              const container = document.createElement("div");
              const componentInstance = new AddressCellComponent({
                propsData: { row: data }
              });

              componentInstance.$on('view-history', (rowData) => {
                this.handleOpenHistory(rowData);
              });

              componentInstance.$on('preview-pdf', (url) => {
                this.openPdfPreview(url);
              });

              componentInstance.$mount(container);

              cell.getTable().on("cellDestroyed", (deletedCell) => {
                if (deletedCell === cell) {
                  componentInstance.$destroy();
                }
              });

              return componentInstance.$el;
            };
          }

          else if (col.key === "custom_field_mls_beds_value") {
            columnConfig.width = 130;
            columnConfig.accessorSort = (value, data) => data.custom_field_mls_beds_value?.type;
            columnConfig.formatter = (cell) => mountVueComponent(cell, BedsCellComponent, {
              row: cell.getData(),
              bedsData: cell.getData().custom_field_mls_beds_value,
              listingType: this.listing_type
            });
          }

          if (col.key === "custom_listing_type") {
            columnConfig.formatter = (cell) => {
              const val = (cell.getValue() || "").toLowerCase();
              let bgColor = "#6c757d";
              let textColor = "#ffffff";

              if (["re-lease", "resale"].includes(val.toLowerCase())) {
                bgColor = "#fc5868";
              } else if (["new lease", "presale"].includes(val)) {
                bgColor = "#426586";
              } else if (val === "assignment") {
                bgColor = "#ffc107";
                textColor = "#000000";
              }

              if (!val) return "-";

              return `<span style="
                display: inline-block;
                padding: 2px 8px;
                border-radius: 12px;
                font-size: 15px;
                font-weight: bold;
                text-transform: uppercase;
                background-color: ${bgColor};
                color: ${textColor};
              ">${val}</span>`;
            };
          }
          if (col.key === "custom_price_confidence") {
            columnConfig.formatter = (cell) => {
              const value = cell.getValue();
              const element = cell.getElement();
              element.style.fontWeight = "bold";

              if (value === "High") element.style.color = "#28a745";      // Green
              else if (value === "Medium") element.style.color = "#ffc107"; // Yellow/Gold
              else if (value === "Low") element.style.color = "#dc3545";    // Red

              return value || "-";
            };
          }
          if (editableNumericFields.includes(col.key)) {
            columnConfig.editor = "number";
            columnConfig.cellEdited = (cell) => {
              const row = cell.getRow();
              const rowData = cell.getData();
              rowData.isEdited = true;
              this.syncDataChange(rowData);
              row.update({ isEdited: true });
            };

            if (!columnConfig.formatter) {
              columnConfig.formatter = (cell) => this.applyNumericFormat(cell.getValue(), false, 0);
            }
          }

          return columnConfig;
        });
      },
      set: function (newVal) { return newVal; }
    },
  },
  methods: {
    prepareFormData(rowData, entryTypes) {
      const fpSpecsSource = [
        { "name": "Furnished", "value": "21170" },
        { "name": "None", "value": "11104" },
        { "name": "Den", "value": "10965" },
        { "name": "Jr Bed", "value": "10971" },
        { "name": "Sub-PH", "value": "10967" },
        { "name": "PH", "value": "10966" },
        { "name": "TH", "value": "10970" },
        { "name": "Roof Deck", "value": "10964" },
        { "name": "Bonus Room", "value": "11040" },
        { "name": "Den (2)", "value": "11132" },
        { "name": "Jr Bed (2)", "value": "21139" },
        { "name": "Live/Work", "value": "11039" },
        { "name": "Lock-Off", "value": "10968" },
        { "name": "Loft", "value": "11028" }
      ];

      const orientationSource = [
        { "text": "None", "value": 11105 },
        { "text": "E", "value": 11033 },
        { "text": "N", "value": 11030 },
        { "text": "NE", "value": 11035 },
        { "text": "NW", "value": 11034 },
        { "text": "S", "value": 11032 },
        { "text": "SE", "value": 11037 },
        { "text": "SW", "value": 11036 },
        { "text": "W", "value": 11031 }
      ];

      const stallsSource = [
        { "text": "None", "value": "11107" },
        { "text": "Pad", "value": "21140" },
        { "text": "Double", "value": "11110" },
        { "text": "Single", "value": "11108" },
        { "text": "Tandem", "value": "11109" },
        { "text": "Triple", "value": "21136" },
        { "text": "U/G", "value": "11111" },
        { "text": "Null", "value": 0 }
      ];

      const levelsSource = [
        { "text": "None", "value": "11106" },
        { "text": "1 Level", "value": "11074" },
        { "text": "2 Level", "value": "11075" },
        { "text": "3 Level", "value": "11076" },
        { "text": "4 Level", "value": "11077" },
        { "text": "5 Level", "value": "11113" }
      ];

      const mlsStatusSource = [
        { "text": "None", "value": 11482 },
        { "text": "Active", "value": 8197 },
        { "text": "Sold", "value": 8198 },
        { "text": "Leased", "value": 8198 },
        { "text": "Unreleased", "value": 23440 }
      ];

      const getMappedValues = (input, sourceArr, matchKey) => {
        if (input === null || input === undefined || input === "-") return "";
        const inputStr = String(input).trim();
        if (!inputStr) return "";

        return inputStr.split(',')
          .map(item => item.trim())
          .map(item => {
            // Look for match in 'text'/'name' or 'value'
            const match = sourceArr.find(s =>
              String(s[matchKey]) === item || String(s.value) === item
            );
            return match ? match.value : item;
          })
          .join(',');
      };

      const parseCustomToISO = (customStr) => {
        if (!customStr || customStr === "-") return "";
        const parts = customStr.split("-");
        if (parts.length !== 3) return customStr;

        const day = parts[0];
        const monthStr = parts[1];
        const yearShort = parts[2];

        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthIndex = monthNames.indexOf(monthStr);
        const month = String(monthIndex + 1).padStart(2, '0');

        const year = parseInt(yearShort) < 70 ? `20${yearShort}` : `19${yearShort}`;

        return `${year}-${month}-${day}`;
      };

      const formData = new FormData();

      formData.append('status', getMappedValues(rowData.custom_status, mlsStatusSource, "text") || 11482);
      formData.append('fp', getMappedValues(rowData.fp_specs, fpSpecsSource, "name"));
      formData.append('orientation', getMappedValues(rowData.orientation, orientationSource, "text"));
      formData.append('pr', getMappedValues(rowData.stalls, stallsSource, "text"));
      formData.append('fl', getMappedValues(rowData.levels, levelsSource, "text"));

      formData.append('bath', rowData.mls_baths || '');
      formData.append('listPrice', rowData.mls_list_price || 0);
      formData.append('soldPrice', rowData.mls_sold_price || 0);
      formData.append('unitSize', rowData.mls_unit_size || 0);
      formData.append('balconyArea', rowData.balcony_area || 0);
      formData.append('unit', rowData.mls_address || '');
      formData.append('balcony', rowData.balcony || '');
      formData.append("buyerIncentives", rowData.buyer_incentives || 0);
      formData.append('assignment', entryTypes.isAssignment || 0);
      formData.append('newEntry', entryTypes.isNewEntry || 0);
      formData.append('originalEntry', entryTypes.isOriginalEntry || 0);

      // if (rowData.pending_file) {
      //   formData.append('backupfile', rowData.pending_file);
      // }
      formData.append('backupfile', rowData.pending_file);
      // Context IDs from URL
      formData.append('uid', this.$route.query.uid || '');
      formData.append('fid', this.$route.query.fid || '');
      formData.append('owner', this.$route.query.owner || '');
      formData.append('purchaser', this.$route.query.purchaser || '');
      // Formatted Dates
      formData.append("soldDate", parseCustomToISO(rowData.mls_sold_date));
      formData.append("listDate", parseCustomToISO(rowData.mls_list_date));
      formData.append("listPriceDate", parseCustomToISO(rowData.mls_price_date));
      formData.append("priceBackup", rowData.price_back_up || '');
      formData.append("realtorIncentives", rowData.realtor_incentives || 0);
      formData.append("bed", rowData.mls_beds || 0);

      return formData;
    },
    async confirmRowSave() {
      this.isBusy = true;
      try {
        const rowsToProcess = [this.rowToSave];
        for (const row of rowsToProcess) {
          const formData = this.prepareFormData(row, this.entryTypeSelection);
          await axios.post(BACKEND_URL + 'api/presale_mls_creation', formData);

          row.isEdited = false;
          row.pending_file = null;
          this.syncDataChange(row);

          if (this.tabulator) {
            const tabRow = this.tabulator.getRow(row.cid);
            if (tabRow) tabRow.update({ isEdited: false, pending_file: null });
          }
        }

        this.$emit('reloadData');
        this.$bvToast.toast(
          this.isBulkSaving ? "All edited rows saved successfully" : "Listing updated successfully",
          { variant: "success" }
        );

        this.saveRowModalShow = false;
      } catch (error) {
        console.error("Submission error:", error);
        this.$bvToast.toast("Failed to save data", { variant: "danger" });
      } finally {
        this.isBusy = false;
        this.isBulkSaving = false;
      }
    },
    handleRowSave(rowData) {
      this.rowToSave = rowData;

      this.entryTypeSelection = {
        isAssignment: 0,
        isNewEntry: 0,
        isOriginalEntry: 0
      };

      this.saveRowModalShow = true;
    },
    toggleView(isTabulator) {

      this.$nextTick(() => {
        this.initializeTabulator();
      });
    },

    setColor(data) {
      const colors = { verified: "#0b36dc", "educated estimated": "#dc3545", "semi-verified": "#FF6F16" };
      return colors[data?.toLowerCase()] || "#000";
    },
    applyNumericFormat(value, isCurrency, precision = 0) {
      if (!this.isRealValue(value)) return "-";

      if (isCurrency) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: precision,
          maximumFractionDigits: precision,
        }).format(value);
      }
      return value;
    },
    isRealValue(value) {
      return !["zero", "", "-", null, 0, undefined, "null", "$0", "0", " ", "0.00", 0.00, "$0.00"].includes(value);
    },
    syncDataChange(updatedRow) {
      const index = this.row_data.findIndex(item => item.cid === updatedRow.cid);
      if (index !== -1) {
        this.$set(this.row_data, index, { ...updatedRow });
      }
    },
    initializeTabulator() {
      const mlsStatusSource = [
        { "text": "None", "value": 11482 },
        { "text": "Active", "value": 8197 },
        { "text": "Sold", "value": 8198 },
        { "text": "Unreleased", "value": 23440 }
      ];

      if (this.$refs.tabulatorTable) {
        this.tabulator = new Tabulator(this.$refs.tabulatorTable, {
          height: "1000px",
          data: this.model_rowdata,
          layout: "fitDataStretch",
          columns: wrapColumns(this.tabulatorColumns),
          reactiveData: false,
          editTriggerEvent: "click",
          popupContainer: "body",
          cellEdited: (cell) => {
            const data = cell.getData();
            this.syncDataChange(data);
          },
          rowFormatter: (row) => {
            const data = row.getData();
            const rawValue = data.custom_status || data.mls_status || "";

            const statusObj = mlsStatusSource.find(s => s.value == rawValue || s.text == rawValue);
            const statusText = (statusObj ? statusObj.text : String(rawValue)).toLowerCase();

            const rowElement = row.getElement();
            const cells = row.getCells();

            let bgColor = "";
            if (statusText === "active") {
              bgColor = "#e8f5e9";
            } else if (statusText === "sold" || statusText === "leased") {
              bgColor = "#ffebee";
            } else if (statusText === "unreleased") {
              bgColor = "#f5f5f5";
            } else {
              bgColor = "#fff";
            }

            if (bgColor) {
              rowElement.style.setProperty('background-color', bgColor, 'important');
              rowElement.style.cursor = "pointer";

              cells.forEach(cell => {
                const cellElement = cell.getElement();
                cellElement.style.setProperty('background-color', bgColor, 'important');
              });
            } else {
              rowElement.style.removeProperty('background-color');
              cells.forEach(cell => cell.getElement().style.removeProperty('background-color'));
            }
          },
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeTabulator();
    });
  },
  watch: {
    tabulatorColumns: {
      handler(newColumns) {
        if (this.tabulator && this.tabulator.initialized) {
          this.$nextTick(() => {
            // This forces Tabulator to redraw with the new column subset
            console.log("Updating Tabulator columns with new configuration...", newColumns);
            this.tabulator.setColumns(newColumns);
          });
        }
      },
      deep: true
    },
    model_rowdata: {
      handler(newData) {
        if (this.tabulator && this.tabulator.initialized) {
          this.tabulator.replaceData(newData).catch(err => {
            console.warn("Tabulator data update suppressed", err);
          });
        }
      },
      deep: true
    },
  },
}
</script>

<style lang="scss" scoped>
.logo-img {
  max-width: 12rem;
}
</style>
